import store from '@/store';
import i18n from '@/plugins/i18n';

async function notify(message, type = 'success') {
  await store.dispatch('addNotification', { message, type });
}

export async function copyToClipboard(text, displayNotification = true, alternativeNotification = false) {
  let success = false;

  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      success = true;
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed'; // prevents scroll jump on iOS
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      success = document.execCommand('copy');
      document.body.removeChild(textArea);
    }

    if (displayNotification) {
      const msg = alternativeNotification || `${i18n.t('notification.copy.to.clipboard.success')}:<br/><u>${text}</u>`;
      await notify(msg, 'success');
    }
  } catch (err) {
    await notify(`${i18n.t('notification.copy.to.clipboard.error')}`, 'error');
    console.error('Copy failed:', err);
  }

  return success;
}
